import { ApiResponse, http } from '@config/api';

export interface Country {
	alpha_two: string;
	alpha_three: string;
	id: string;
	name: string;
}

export async function getCountries() {
	const response = await http.get<ApiResponse<Country[]>>('countries', 'list/');

	return response.data;
}
